import { render } from "./MyIntroduction.vue?vue&type=template&id=ae9e0486&scoped=true"
const script = {}

import "./MyIntroduction.vue?vue&type=style&index=0&id=ae9e0486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae9e0486"]])

export default __exports__